import { useEffect, useState } from 'react';
import { useLinkedIn } from 'react-linkedin-login-oauth2';
import linkedin from 'react-linkedin-login-oauth2/assets/linkedin.png';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { GetLinkedinToken } from '../../../api/marketing';
import { useQuery } from '@tanstack/react-query';

const LinkedInShareButton = ({ post, setShowSocialPost, linkedinTokenFlag }) => {
  const [authCode, setAuthCode] = useState();

  const { linkedInLogin } = useLinkedIn({
    clientId: '77dg8kiavtggia',
    redirectUri: `${window.location.origin}/ContentMgt/SocialMedia/linkedin`,
    onSuccess: async (code) => {
      setAuthCode(code);
    },
    scope: 'w_member_social rw_organization_admin r_basicprofile w_organization_social',
    onError: (error) => {
      console.log(error);
    },
  });

  const query = useQuery({
    queryKey: ['GetLinkedinToken'],
    queryFn: GetLinkedinToken(
      [
        { queryParam: 'code', queryVal: authCode },
        {
          queryParam: 'redirectUri',
          queryVal: `${window.location.origin}/ContentMgt/SocialMedia/linkedin`,
        },
      ],
      linkedinTokenFlag
    ),
    enabled: !!authCode,
  });

  useEffect(() => {
    if (query.isSuccess && query.data) {
      const data = query.data;
      const { access_token, expires_in } = data;

      const expiresDate = new Date();
      expiresDate.setSeconds(expiresDate.getSeconds() + expires_in);
      localStorage.setItem('linkedinTokenExpires', expiresDate.toISOString());

      const pageOptions = data?.pageOptions?.map(({ id, name }) => ({
        value: id,
        label: name,
        accessToken: access_token,
        pageId: id,
      }));

      const postData = {
        selectedNetwork: 'Linkedln',
        pageOptions,
        ...post,
        defaultPageId: pageOptions[0],
      };
      localStorage.setItem('linkedinPostData', JSON.stringify(postData));
      setShowSocialPost(postData);
    }
  }, [query.isSuccess, query.data]);

  return (
    <LinkedInIcon
      className="link-feel"
      /*onClick={(e) => {
            let postData = JSON.parse(localStorage.getItem('linkedinPostData'));
            if (!linkedInLogin || postData === null) {
                return linkedInLogin(e)
            } else {
                if (post) {
                    postData = {...postData, ...post};
                }
                setShowSocialPost(postData);
            }
        }}*/ fontSize="small"
    />
  );
};

export default LinkedInShareButton;
